import React from 'react';
import { Tooltip } from 'antd';
import './FunnelChart.scss';
import { formatNumber } from '../../../utils/format';

const BudgetVisualization = ({ budgetData }) => {
  // Format currency in millions
  const formatCurrency = (value) => {
    return `$${Math.abs(value / 1000000).toFixed(2)}M`;
  };

  // Format percentage
  const formatPercentage = (value, total) => {
    return `${Math.abs((value / total) * 100).toFixed(2)}%`;
  };

  const sortedEntries = Object.entries(budgetData).sort((a, b) => b[1] - a[1]);

  // console.log(sortedEntries[0][1]);

  // Calculate percentages
  const totalBudgetPercent =
    (budgetData?.totalBudget / sortedEntries[0][1]) * 100;
  const spentPercentage = (budgetData?.spent / sortedEntries[0][1]) * 100;
  const leftPercentage = (budgetData?.leftToSpend / sortedEntries[0][1]) * 100;

  // Tooltip content components
  const totalBudgetTooltip = (
    <div className='budget-tooltip'>
      <div className='tooltip-title'>Total Budget</div>
      <div>Amount: ${formatNumber(budgetData?.totalBudget)}</div>
      <div>percent: 100%</div>
    </div>
  );

  const spentTooltip = (
    <div className='budget-tooltip'>
      <div className='tooltip-title'>Budget Spent</div>
      <div>
        Amount:{' '}
        {budgetData?.spent < 0
          ? `($${formatNumber(Math.abs(budgetData?.spent))})`
          : `$${formatNumber(budgetData?.spent)}`}
      </div>
      <div>
        Percentage:{' '}
        {formatPercentage(budgetData?.spent, budgetData?.totalBudget)}
      </div>
    </div>
  );

  const leftToSpendTooltip = (
    <div className='budget-tooltip'>
      <div className='tooltip-title'>Left to Spend</div>
      <div>
        Amount:{' '}
        {budgetData?.leftToSpend < 0
          ? `($${formatNumber(Math.abs(budgetData?.leftToSpend))})`
          : `$${formatNumber(budgetData?.leftToSpend)}`}
      </div>
      <div>
        Percentage:{' '}
        {formatPercentage(budgetData?.leftToSpend, budgetData?.totalBudget)}
      </div>
      <div
        className={
          budgetData?.leftToSpend < 0 ? 'negative-text' : 'positive-text'
        }
      >
        Status: {budgetData?.leftToSpend < 0 ? 'Over budget' : 'Under budget'}
      </div>
    </div>
  );

  return (
    <div className='budget-container'>
      <div className='budget-row'>
        <div className='budget-label'>Total Budget</div>
        <div className='bar-container'>
          <Tooltip
            title={totalBudgetTooltip}
            placement='top'
            mouseEnterDelay={0.1}
            mouseLeaveDelay={0.1}
            ClassName='budget-tooltip-wrapper'
            color='white'
          >
            <div
              className='budget-bar'
              style={{
                width: `${Math.min(Math.abs(totalBudgetPercent), 100)}%`,
              }}
            >
              {formatCurrency(budgetData?.totalBudget)}
            </div>
          </Tooltip>
        </div>
      </div>

      <div className='budget-row'>
        <div className='budget-label'>Spent</div>
        <div className='bar-container'>
          <Tooltip
            title={spentTooltip}
            placement='top'
            mouseEnterDelay={0.1}
            mouseLeaveDelay={0.1}
            ClassName='budget-tooltip-wrapper'
            color='white'
          >
            <div
              className='budget-bar'
              style={{ width: `${Math.min(Math.abs(spentPercentage), 100)}%` }}
            >
              {formatCurrency(budgetData?.spent)} |{' '}
              {formatPercentage(budgetData?.spent, budgetData?.totalBudget)}
            </div>
          </Tooltip>
        </div>
      </div>

      <div className='budget-row'>
        <div className='budget-label'>Left to spend</div>
        <div className='bar-container'>
          <Tooltip
            title={leftToSpendTooltip}
            placement='top'
            mouseEnterDelay={0.1}
            mouseLeaveDelay={0.1}
            ClassName='budget-tooltip-wrapper'
            color='white'
          >
            <div
              className={`budget-bar ${
                budgetData?.leftToSpend < 0 ? 'negative' : ''
              }`}
              style={{ width: `${Math.min(Math.abs(leftPercentage), 100)}%` }}
            >
              {budgetData?.leftToSpend > 0
                ? formatCurrency(budgetData?.leftToSpend)
                : `(${formatCurrency(Math.abs(budgetData?.leftToSpend))})`}
              |{' '}
              {formatPercentage(
                budgetData?.leftToSpend,
                budgetData?.totalBudget
              )}
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default BudgetVisualization;
